import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppInterfaceConfig, AppThemePalette } from "@interfaces/theme";

// const THEME_API_URL = import.meta.env.VITE_URL_THEME_API as string | undefined;

export interface ThemeState {
  palette: AppThemePalette | null;
  interface: AppInterfaceConfig | null;
  loading: boolean;
  error: string | null;
}

const initialState: ThemeState = {
  palette: null,
  interface: null,
  loading: false,
  error: null,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setThemeConfig: (
      state,
      action: PayloadAction<{
        palette: AppThemePalette | null;
        interface: AppInterfaceConfig | null;
      }>,
    ) => {
      if (action.payload.palette) {
        state.palette = action.payload.palette;
      }
      if (action.payload.interface) {
        state.interface = action.payload.interface;
      }
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setThemeConfig, setLoading } = themeSlice.actions;
export default themeSlice.reducer;
